import React from "react";
import { GoalProgress } from "../../types/kpiGoals";
import GoalProgressCard from "./GoalProgressCard";

interface GoalProgressSectionProps {
  goals: GoalProgress[];
}

const GoalProgressSection: React.FC<GoalProgressSectionProps> = ({
  goals,
}) => {
  if (goals.length === 0) return null;

  return (
    <div className="mb-8">
      <h3 className="text-lg font-medium text-gray-700 mb-4">Goal Progress</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {goals.map((progress) => (
          <GoalProgressCard key={progress.goal.id} progress={progress} />
        ))}
      </div>
    </div>
  );
};

export default GoalProgressSection;
